import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import primaryComponents from "../../primaryComponents";

const AddAccountDropdown = ({
  setShowAddBankAccount,
  setShowAddChartAccount,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const accountMenu = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!accountMenu.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div style={{ position: "relative", zIndex: 2 }} ref={accountMenu}>
        <primaryComponents.Button
          onClick={() => setShowDropdown(!showDropdown)}
          classNames="btn btn--primary"
        >
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon="angle-down" style={{ fontSize: "18px" }} />
            <span className="default-text-size pl-2">Add New</span>
          </div>
        </primaryComponents.Button>
        {showDropdown ? (
          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            className={styles.dropdown}
          >
            <p
              className="dark--text"
              onClick={() => setShowAddBankAccount(true)}
            >
              Bank Account
            </p>
            <p
              className="dark--text"
              onClick={() => setShowAddChartAccount(true)}
            >
              Chart of Account
            </p>
          </motion.div>
        ) : null}
      </div>
    </>
  );
};

export default AddAccountDropdown;
